(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["donreloj-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('donreloj-stories')) {
    customElements.define('donreloj-stories', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('.drs-dialog');
        this.stage = this.querySelector('.drs-stage');
        this.mediaBox = this.querySelector('[data-drs-media]');
        this.progress = this.querySelector('[data-drs-progress]');
        this.titleBox = this.querySelector('[data-drs-title]');
        this.status = this.querySelector('[data-drs-status]');
        this.linkBox = this.querySelector('[data-drs-link]');
        this.pauseButton = this.querySelector('[data-drs-pause]');
        this.soundButton = this.querySelector('[data-drs-sound]');
        this.errorBox = this.querySelector('[data-drs-error]');
        this.groups = Array.from(this.querySelectorAll('[data-drs-open]')).filter(button => button.dataset.available === 'true').map(button => {
          const template = button.parentElement.querySelector('template[data-drs-group]');
          return { button, template, frames: Array.from(template.content.querySelectorAll('template[data-drs-frame]')) };
        }).filter(group => group.frames.length);
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.duration = Math.max(3, Number(this.dataset.duration) || 6) * 1000;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reducedMotion;
        this.muted = true;
        this.groupIndex = 0;
        this.frameIndex = 0;
        this.storageKey = 'donreloj-stories-v1:' + this.dataset.sectionId;
        try { this.seen = new Set(JSON.parse(sessionStorage.getItem(this.storageKey) || '[]')); } catch { this.seen = new Set(); }
        this.groups.forEach((group, index) => {
          group.seenKey = this.contentKey(group);
          group.button.classList.toggle('drs-seen', this.seen.has(group.seenKey));
          group.button.addEventListener('click', () => this.open(index), options);
        });
        this.querySelector('[data-drs-close]').addEventListener('click', () => this.close(), options);
        this.pauseButton.addEventListener('click', () => {
          this.manualPaused = !this.manualPaused;
          this.syncPlayback();
        }, options);
        this.soundButton.addEventListener('click', () => {
          this.muted = !this.muted;
          if (this.video) this.video.muted = this.muted;
          this.updateControls();
        }, options);
        this.dialog.addEventListener('close', () => this.cleanup(), options);
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.close(); }, options);
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight') { event.preventDefault(); this.next(); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.previous(); }
          if (event.code === 'Space' && event.target === this.dialog) {
            event.preventDefault(); this.manualPaused = !this.manualPaused; this.syncPlayback();
          }
        }, options);
        this.querySelectorAll('[data-drs-step]').forEach(button => {
          button.addEventListener('click', event => {
            if (event.detail === 0) Number(button.dataset.drsStep) > 0 ? this.next() : this.previous();
          }, options);
        });
        this.stage.addEventListener('pointerdown', event => this.pointerDown(event), options);
        this.stage.addEventListener('pointerup', event => this.pointerUp(event), options);
        this.stage.addEventListener('pointercancel', () => this.releaseHold(), options);
        this.stage.addEventListener('lostpointercapture', () => this.releaseHold(), options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.dialog.addEventListener('focusin', event => {
          this.linkFocused = Boolean(event.target.closest('.drs-cta'));
          this.syncPlayback();
        }, options);
        this.dialog.addEventListener('focusout', () => {
          queueMicrotask(() => { this.linkFocused = Boolean(this.dialog.querySelector('.drs-cta:focus')); this.syncPlayback(); });
        }, options);
        document.addEventListener('shopify:section:unload', event => {
          if (event.detail.sectionId === this.dataset.sectionId) this.close();
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.groups.findIndex(group => group.button.dataset.drsOpen === event.detail.blockId);
          if (index >= 0) { this.open(index); this.manualPaused = true; this.syncPlayback(); }
        }, options);
        const list = this.querySelector('.drs-list');
        this.querySelectorAll('[data-drs-scroll]').forEach(button => button.addEventListener('click', () => {
          list.scrollBy({ left: Number(button.dataset.drsScroll) * list.clientWidth * .75, behavior: this.reducedMotion ? 'auto' : 'smooth' });
        }, options));
        this.resizeObserver = new ResizeObserver(() => {
          this.querySelector('.drs-scroll-controls').hidden = list.scrollWidth <= list.clientWidth + 2;
        });
        this.resizeObserver.observe(list);
        this.querySelector('[data-drs-share]').addEventListener('click', () => this.shareStory(), options);
        window.addEventListener('popstate', () => this.openSharedStory(), options);
        this.openSharedStory();
      }
      disconnectedCallback() {
        this.close();
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.controller = null;
      }
      openSharedStory() {
        const key = new URL(window.location.href).searchParams.get('historia');
        if (!key || this.dataset.designMode === 'true') return;
        for (let index = 0; index < this.groups.length; index++) {
          const frame = this.groups[index].frames.findIndex(item => item.dataset.storyKey === key);
          if (frame < 0) continue;
          this.open(index, frame);
          return;
        }
      }
      storyUrl() {
        const url = new URL(this.dataset.homeUrl, window.location.origin);
        url.searchParams.set('historia', this.groups[this.groupIndex].frames[this.frameIndex].dataset.storyKey);
        if (window.Shopify?.theme?.role === 'unpublished') {
          url.searchParams.set('preview_theme_id', String(window.Shopify.theme.id));
        }
        return url.href;
      }
      async shareStory() {
        if (this.sharing || !this.dialog.open) return;
        this.sharing = true;
        this.syncPlayback();
        const url = this.storyUrl();
        const title = 'DONRELOJ · ' + this.groups[this.groupIndex].button.dataset.title;
        const feedback = this.querySelector('[data-drs-share-feedback]');
        const message = this.querySelector('[data-drs-share-message]');
        const input = this.querySelector('[data-drs-share-url]');
        feedback.hidden = true;
        input.hidden = true;
        try {
          if (navigator.share) {
            try { await navigator.share({ title, url }); return; }
            catch (error) { if (error.name === 'AbortError') return; }
          }
          if (!navigator.clipboard?.writeText) throw new Error('clipboard');
          await navigator.clipboard.writeText(url);
          message.textContent = this.dataset.shareCopied;
          feedback.hidden = false;
          this.status.textContent = this.dataset.shareCopied;
        } catch {
          message.textContent = this.dataset.shareManual;
          input.value = url;
          input.hidden = false;
          feedback.hidden = false;
          this.manualPaused = true;
          input.focus();
          input.select();
        } finally {
          this.sharing = false;
          this.syncPlayback();
        }
      }
      contentKey(group) {
        const data = group.frames.map(frame => frame.innerHTML).join('');
        let hash = 0;
        for (let i = 0; i < data.length; i++) hash = ((hash << 5) - hash + data.charCodeAt(i)) | 0;
        return group.button.dataset.drsOpen + ':' + hash;
      }
      open(index, frame = 0) {
        document.querySelectorAll('donreloj-stories').forEach(other => { if (other !== this) other.close?.(); });
        if (!this.dialog.open) {
          this.opener = this.groups[index].button;
          this.previousOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          this.locked = true;
          this.dialog.showModal();
        }
        this.manualPaused = this.reducedMotion || this.dataset.designMode === 'true';
        this.linkFocused = false;
        this.showGroup(index, false, frame);
        this.querySelector('[data-drs-close]').focus({ preventScroll: true });
        cancelAnimationFrame(this.animation);
        this.lastTick = performance.now();
        this.animation = requestAnimationFrame(time => this.tick(time));
      }
      showGroup(index, lastFrame = false, frame = 0) {
        this.groupIndex = index;
        const group = this.groups[index];
        this.frameIndex = lastFrame ? group.frames.length - 1 : frame;
        this.titleBox.textContent = group.button.dataset.title;
        this.stage.dataset.fit = group.template.dataset.fit;
        this.linkBox.replaceChildren();
        const link = group.template.content.querySelector('.drs-cta');
        if (link) this.linkBox.append(link.cloneNode(true));
        this.progress.replaceChildren();
        this.bars = group.frames.map(() => {
          const track = document.createElement('span');
          const fill = document.createElement('span');
          track.className = 'drs-progress-track';
          fill.className = 'drs-progress-fill';
          track.append(fill);
          this.progress.append(track);
          return fill;
        });
        this.renderFrame();
      }
      renderFrame() {
        this.frameController?.abort();
        this.frameController = new AbortController();
        const options = { signal: this.frameController.signal };
        if (this.video) this.video.pause();
        this.video = null;
        this.elapsed = 0;
        this.ready = false;
        this.holding = false;
        this.pointer = null;
        this.errorBox.hidden = true;
        this.querySelector('[data-drs-share-feedback]').hidden = true;
        this.lastTick = performance.now();
        const group = this.groups[this.groupIndex];
        this.mediaBox.replaceChildren(group.frames[this.frameIndex].content.cloneNode(true));
        this.bars.forEach((bar, index) => bar.style.transform = `scaleX(${index < this.frameIndex ? 1 : 0})`);
        this.status.textContent = group.button.dataset.title + ' · ' + (this.frameIndex + 1) + ' / ' + group.frames.length;
        const media = this.mediaBox.querySelector('img,video');
        const fail = () => { this.ready = false; this.errorBox.hidden = false; this.manualPaused = true; this.syncPlayback(); };
        if (media.tagName === 'VIDEO') {
          this.video = media;
          media.muted = this.muted;
          media.playsInline = true;
          media.preload = 'auto';
          media.addEventListener('loadeddata', () => { this.ready = true; this.syncPlayback(); }, options);
          media.addEventListener('error', fail, options);
          media.addEventListener('ended', () => {
            this.bars[this.frameIndex].style.transform = 'scaleX(1)';
            if (this.autoplay && !this.manualPaused) this.next();
            else this.markSeenIfLast();
          }, options);
          media.load();
        } else {
          media.addEventListener('load', () => { this.ready = true; this.lastTick = performance.now(); }, options);
          media.addEventListener('error', fail, options);
          if (media.complete) { if (media.naturalWidth > 0) this.ready = true; else fail(); }
        }
        this.soundButton.hidden = !this.video;
        this.syncPlayback();
      }
      isPaused() {
        return this.sharing || this.manualPaused || this.holding || this.linkFocused || document.hidden || !this.dialog.open;
      }
      syncPlayback() {
        if (!this.dialog) return;
        this.lastTick = performance.now();
        if (this.video) {
          if (this.isPaused()) this.video.pause();
          else if (this.ready && this.video.paused && !this.video.ended) {
            const video = this.video;
            video.play()?.catch(() => {
              if (this.video === video && this.dialog.open && !this.isPaused()) {
                this.manualPaused = true;
                this.updateControls();
              }
            });
          }
        }
        this.updateControls();
      }
      updateControls() {
        this.pauseButton.setAttribute('aria-label', this.manualPaused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.pauseButton.setAttribute('aria-pressed', String(Boolean(this.manualPaused)));
        this.querySelector('[data-drs-pause-icon]').textContent = this.manualPaused ? '▶' : 'Ⅱ';
        this.soundButton.setAttribute('aria-label', this.muted ? this.dataset.unmuteLabel : this.dataset.muteLabel);
        this.soundButton.setAttribute('aria-pressed', String(!this.muted));
      }
      tick(time) {
        if (!this.dialog.open) return;
        const delta = Math.min(100, Math.max(0, time - this.lastTick));
        this.lastTick = time;
        if (this.ready && !this.isPaused()) {
          if (this.video) {
            if (Number.isFinite(this.video.duration) && this.video.duration > 0) {
              this.bars[this.frameIndex].style.transform = `scaleX(${Math.min(1, this.video.currentTime / this.video.duration)})`;
            }
          } else if (this.autoplay) {
            this.elapsed += delta;
            this.bars[this.frameIndex].style.transform = `scaleX(${Math.min(1, this.elapsed / this.duration)})`;
            if (this.elapsed >= this.duration) this.next();
          }
        }
        if (this.dialog.open) this.animation = requestAnimationFrame(nextTime => this.tick(nextTime));
      }
      markSeenIfLast() {
        const group = this.groups[this.groupIndex];
        if (this.frameIndex !== group.frames.length - 1) return;
        this.seen.add(group.seenKey);
        group.button.classList.add('drs-seen');
        try { sessionStorage.setItem(this.storageKey, JSON.stringify(Array.from(this.seen))); } catch {}
      }
      next() {
        if (!this.dialog.open) return;
        this.markSeenIfLast();
        if (this.frameIndex < this.groups[this.groupIndex].frames.length - 1) { this.frameIndex++; this.renderFrame(); }
        else if (this.groupIndex < this.groups.length - 1) this.showGroup(this.groupIndex + 1);
        else this.close();
      }
      previous() {
        if (!this.dialog.open) return;
        if (this.frameIndex > 0) { this.frameIndex--; this.renderFrame(); }
        else if (this.groupIndex > 0) this.showGroup(this.groupIndex - 1, true);
        else this.renderFrame();
      }
      pointerDown(event) {
        if (!event.isPrimary || event.button !== 0 || event.target.closest('.drs-control,.drs-cta,.drs-share-feedback')) return;
        this.pointer = { x: event.clientX, y: event.clientY, start: performance.now(), id: event.pointerId };
        this.holding = true;
        this.stage.setPointerCapture(event.pointerId);
        this.syncPlayback();
      }
      pointerUp(event) {
        if (!this.pointer || this.pointer.id !== event.pointerId) return;
        const pointer = this.pointer;
        const dx = event.clientX - pointer.x;
        const dy = event.clientY - pointer.y;
        const held = performance.now() - pointer.start;
        this.releaseHold();
        if (Math.abs(dy) > 80 && Math.abs(dy) > Math.abs(dx)) { if (dy > 0) this.close(); return; }
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { dx < 0 ? this.next() : this.previous(); return; }
        if (held < 280 && Math.abs(dx) < 12 && Math.abs(dy) < 12) {
          const bounds = this.stage.getBoundingClientRect();
          event.clientX - bounds.left < bounds.width * .35 ? this.previous() : this.next();
        }
      }
      releaseHold() {
        this.pointer = null;
        this.holding = false;
        this.syncPlayback();
      }
      close() {
        if (this.dialog?.open) this.dialog.close();
        this.cleanup();
      }
      cleanup() {
        cancelAnimationFrame(this.animation);
        this.frameController?.abort();
        if (this.video) this.video.pause();
        this.video = null;
        this.mediaBox?.replaceChildren();
        if (this.locked) {
          document.documentElement.style.overflow = this.previousOverflow;
          this.locked = false;
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-banner-carousel"] && !Shopify.designMode) return;
  try {
    
class DrBannerCarousel extends HTMLElement {
connectedCallback(){
this.abort?.abort();this.abort=new AbortController();const options={signal:this.abort.signal};
this.slides=[...this.querySelectorAll('.drbc-slide')];this.dots=[...this.querySelectorAll('[data-go]')];this.index=0;
this.viewport=this.querySelector('.drbc-viewport');this.track=this.querySelector('.drbc-track');
this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.running=this.dataset.autoplay==='true'&&!this.reduced.matches&&navigator.connection?.saveData!==true;
this.querySelector('.drbc-controls')?.removeAttribute('hidden');
this.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;if(b.hasAttribute('data-toggle')){this.running=!this.running;this.update();return;}if(b.hasAttribute('data-go'))this.go(Number(b.dataset.go),true);if(b.hasAttribute('data-prev'))this.go(this.index-1,true);if(b.hasAttribute('data-next'))this.go(this.index+1,true);},options);
this.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.go(this.index+(e.key==='ArrowRight'?1:-1),true);}},options);

this.addEventListener('focusin',e=>{if(e.target.matches(':focus-visible')){this.running=false;this.update();}},options);
this.addEventListener('touchstart',e=>{this.startX=e.touches[0].clientX;this.startY=e.touches[0].clientY;},{...options,passive:true});
this.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-this.startX,dy=e.changedTouches[0].clientY-this.startY;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy))this.go(this.index+(dx<0?1:-1),true);},{...options,passive:true});
document.addEventListener('visibilitychange',()=>this.schedule(),options);
document.addEventListener('shopify:block:select',e=>{const n=this.slides.findIndex(s=>s.dataset.block===e.detail.blockId);if(n>=0)this.go(n,true);},options);
this.reduced.addEventListener('change',()=>{if(this.reduced.matches){this.running=false;this.update();}},options);
this.resize=new ResizeObserver(()=>this.measure());this.slides.forEach(s=>this.resize.observe(s));this.update();
}
measure(){this.viewport.style.removeProperty('height');}
go(n,manual=false){if(!this.slides.length)return;if(manual)this.running=false;const previous=this.index;const direction=n<this.index?1:-1;this.index=(n+this.slides.length)%this.slides.length;this.update();this.animateSlides(previous,direction);}
animateSlides(previous,direction){
this.animations?.forEach(a=>a.cancel());this.slides.forEach(s=>s.style.visibility='');
if(previous===this.index||this.reduced.matches)return;
const outgoing=this.slides[previous],incoming=this.slides[this.index];outgoing.style.visibility='visible';
const options={duration:650,easing:'cubic-bezier(.22,.68,.18,1)'};
const exit=outgoing.animate([{transform:'translateX(0)'},{transform:'translateX('+(direction*100)+'%)'}],options);
const enter=incoming.animate([{transform:'translateX('+(-direction*100)+'%)'},{transform:'translateX(0)'}],options);
this.animations=[exit,enter];exit.onfinish=()=>{outgoing.style.visibility='';};
}
update(){const deferred=this.slides[this.index]?.querySelector('template[data-dr-deferred]');if(deferred)deferred.replaceWith(deferred.content.cloneNode(true));this.slides.forEach((s,i)=>{s.inert=i!==this.index;s.setAttribute('aria-hidden',String(i!==this.index));});this.dots.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===this.index)));const t=this.querySelector('[data-toggle]');if(t){t.setAttribute('aria-label',this.running?this.dataset.pause:this.dataset.play);t.querySelector('[data-pause-icon]').hidden=!this.running;t.querySelector('[data-play-icon]').hidden=this.running;}this.measure();this.schedule();}
schedule(){clearTimeout(this.timer);if(this.running&&!document.hidden&&this.slides.length>1)this.timer=setTimeout(()=>this.go(this.index+1),Number(this.dataset.interval)||4000);}
disconnectedCallback(){this.animations?.forEach(a=>a.cancel());clearTimeout(this.timer);this.abort?.abort();this.resize?.disconnect();}
}
if(!customElements.get('dr-banner-carousel'))customElements.define('dr-banner-carousel',DrBannerCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-daily-popup"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dr-daily-popup'))customElements.define('dr-daily-popup',class extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const options={signal:this.abort.signal};
  this.modal=this.querySelector('dialog');if(!this.modal||window.Shopify?.designMode)return;
  this.key='donreloj-daily-popup-shown-v1';this.duration=24*60*60*1000;
  this.readTime=()=>{try{return Math.max(Number(localStorage.getItem(this.key))||0,Number(sessionStorage.getItem(this.key))||0);}catch{return this.lastShown||0;}};
  this.dismiss=()=>this.modal.close();
  this.querySelector('.dr-drop-close').addEventListener('click',this.dismiss,options);
  this.querySelector('.dr-drop-later').addEventListener('click',this.dismiss,options);
  this.modal.addEventListener('click',e=>{if(e.target===this.modal){const b=this.modal.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)this.dismiss();}},options);
  const show=()=>{
   if(!this.isConnected||this.modal.open||Date.now()-this.readTime()<this.duration)return;
   if(document.hidden||document.querySelector('dialog[open]')){this.timer=setTimeout(show,5000);return;}
   const templates=[...this.querySelectorAll('template[data-drop-banner]')];if(!templates.length)return;
   const chosen=templates[Math.floor(Math.random()*templates.length)].content.cloneNode(true);
   this.querySelector('[data-drop-cta]').href=chosen.querySelector('a').href;
   this.querySelector('[data-drop-content]').replaceChildren(chosen);
   this.modal.showModal();this.lastShown=Date.now();
   try{localStorage.setItem(this.key,String(this.lastShown));}catch{}
   try{sessionStorage.setItem(this.key,String(this.lastShown));}catch{}
  };
  this.timer=setTimeout(show,5000);
 }
 disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();if(this.modal?.open)this.modal.close();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marcas-principales"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('donreloj-brand-slider')) {
    customElements.define('donreloj-brand-slider', class extends HTMLElement {
      connectedCallback() { this.addEventListener('click', this.handleNavigation); }
      disconnectedCallback() { this.removeEventListener('click', this.handleNavigation); }
      handleNavigation(event) {
        const button = event.target.closest('button[data-direction]');
        const slider = this.querySelector('.marcas-slider');
        if (!button || !this.contains(button) || !slider) return;
        slider.scrollBy({
          left: Number(button.dataset.direction) * slider.clientWidth * 0.8,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
